
export class TileDefinition {

  titleDictionaryKey: string;
  titleIconCss: string;
  descriptionDictionaryKey: string;
  key: string;

  constructor(data?: any) {
    if (data != null) {
      this.titleDictionaryKey = data.titleDictionaryKey;
      this.titleIconCss = data.titleIconCss;
      this.descriptionDictionaryKey = data.descriptionDictionaryKey;
      this.key = data.key;
    }
  }
}
